module.exports = __webpack_public_path__ + "img/c07_unitchief_Normal_ua.a5aa2dbc.webp";